module.exports = __webpack_public_path__ + "static/media/vesper.0941a205.jpeg";